import {
  BlocoEndereco,
  Chamada,
  Fechamento,
  GrupoTitulo,
  LinkEndereco,
  Painel,
  Paragrafo,
  RotuloEndereco,
  Selo,
  Titulo,
} from './AvisoRebranding.style'

/**
 * Endereco anunciado no aviso. Fixo em PRODUCAO de proposito, e nao derivado do
 * host atual: o aviso existe para quem ainda chega pelo dominio antigo
 * (web.predict.app.br, que segue no ar), e nesse caso o host atual seria
 * justamente o endereco errado a divulgar.
 */
const URL_NOVO_ENDERECO = 'https://app.cartivia.com.br'

const ID_TITULO = 'aviso-rebranding-titulo'

/**
 * Comunicado da troca de marca Predict -> Cartivia na tela de login.
 *
 * Fixo por decisao (2026-09-04): sem botao de dispensar e sem prazo em codigo —
 * sai quando o produto pedir. A assinatura da marca ("Cartivia — a inteligencia
 * da sua carteira ativa") NAO se repete aqui: o cartao de login ao lado ja a
 * exibe via `LogoCartivia comTagline`.
 *
 * Para REMOVER o aviso sao duas edicoes em `pages/Login/Login.tsx`: tirar o
 * `<AvisoRebranding />` e devolver o `AreaLogin` do ramo de login para
 * `RealizeSeuLogin` — senao o cartao fica com o `margin: 0` que o `AreaLogin`
 * aplica, no lugar do `margin: 40px auto` original.
 */
export function AvisoRebranding() {
  return (
    <Painel aria-labelledby={ID_TITULO}>
      <Selo>Novo endereço</Selo>
      <GrupoTitulo>
        <Titulo id={ID_TITULO}>
          O Predict agora é <strong>Cartivia</strong>.
        </Titulo>
        <Chamada>Estamos evoluindo.</Chamada>
      </GrupoTitulo>
      <Paragrafo>
        O Predict agora faz parte de uma plataforma mais completa, criada para
        ajudar sua empresa a extrair o máximo potencial da sua carteira de
        clientes.
      </Paragrafo>
      <BlocoEndereco>
        <RotuloEndereco>
          A partir de agora, você acessará o sistema pelo novo endereço:
        </RotuloEndereco>
        <LinkEndereco href={URL_NOVO_ENDERECO}>
          {URL_NOVO_ENDERECO}
        </LinkEndereco>
      </BlocoEndereco>
      <Paragrafo>
        Suas informações e funcionalidades continuam com você. O que muda é a
        nossa marca, o endereço de acesso e, principalmente, a evolução do
        produto.
      </Paragrafo>
      <Paragrafo>
        O Cartivia amplia a inteligência sobre sua carteira, ajudando sua equipe
        a identificar o momento certo de recompra, oportunidades de expansão de
        mix e sinais de perda de clientes.
      </Paragrafo>
      <Fechamento>
        Você já conhece o Predict. Agora, conheça o Cartivia.
      </Fechamento>
    </Painel>
  )
}
